import { Component, Input, OnInit } from '@angular/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'language',
    template: '{{ translation }}',
    standalone: false,
})
export class LanguageComponent implements OnInit {
    @Input() language: string = '';

    translation: string = '';

    constructor (private pipeService: PipeService) {}

    ngOnInit (): void {
        this.translation = this.pipeService.get('translateLanguage')(this.language);
    }
}
